import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import { NOTICE_TYPES } from '../../common/constants';
import yellowIcon from '../../images/notice_icon_yellow.svg';
import redIcon from '../../images/notice_icon_red.svg';
import grayIcon from '../../images/notice_icon_gray.svg';
import brownIcon from '../../images/notice_icon_brown.svg';

const style = { width: '24px', height: '24px' };

export const YellowChipIcon = (
  <Avatar src={yellowIcon} variant="square" alt='速度規制' sx={style} />
);

export const RedChipIcon = (
  <Avatar src={redIcon} variant="square" alt='運転中止' sx={style} />
);

export const GrayChipIcon = (
  <Avatar src={grayIcon} variant="square" alt='解除' sx={style} />
);

export const BrownChipIcon = (
  <Avatar src={brownIcon} variant="square" alt='計画徐行' sx={style} />
);

const NoticeTypeIcon = (props) => {
  const { noticeTypeCode, sx } = props;
  let src = null;
  let alt = null;
  switch (noticeTypeCode) {
    case NOTICE_TYPES.THIRTY_FIVE_LIMIT.value:
      src = yellowIcon;
      alt = '速度規制';
      break;
    case NOTICE_TYPES.TWENTY_FIVE_LIMIT.value:
      src = yellowIcon;
      alt = '速度規制';
      break;
    case NOTICE_TYPES.SUSPENSION.value:
      src = redIcon;
      alt = '運転中止';
      break;
    case NOTICE_TYPES.LIMIT_CANCEL.value:
      src = grayIcon;
      alt = '解除';
      break;
    case NOTICE_TYPES.SUSPENSION_CANCEL.value:
      src = grayIcon;
      alt = '解除';
      break;
    case NOTICE_TYPES.SLOWDOWN.value:
      src = brownIcon;
      alt = '計画徐行';
      break;
  };
  return <Avatar src={src} variant='square' alt={alt} sx={sx} />;
};

export default NoticeTypeIcon;

NoticeTypeIcon.propTypes = {
  noticeTypeCode: PropTypes.number,
  sx: PropTypes.object,
};
